module.exports = "/_next/static/images/b9ff1a008555c1b5c46bea862dc4999a-cajita.svg.webp";